function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable camelcase */
// region Storefront API Types

/**
 * @typedef {Object} Cart
 * @property {string} id - The unique identifier of the cart.
 * @property {Array.<CartLine>} lines - The lines of the cart.
 * @property {Array.<Attribute>} attributes - The attributes of the cart.
 */

/**
 * @typedef {Object} CartLineInput
 * @property {number} quantity - The quantity of the cart line.
 * @property {string} merchandiseId - The merchandise id of the cart line.
 * @property {Array.<Attribute>} attributes - The attributes of the cart line.
 */

/**
 * @typedef {Object} MoneyV2
 * @property {string} amount - The amount of money.
 * @property {string} currencyCode - The currency code of the money.
 */

/**
 * @typedef {Object} CartCost
 * @property {MoneyV2} checkoutChargeAmount - The checkout charge amount.
 * @property {MoneyV2} subtotalAmount - The subtotal amount.
 * @property {MoneyV2} totalTaxAmount - The total tax amount.
 * @property {boolean} totalTaxAmountEstimated - Whether the total tax amount is estimated.
 */

/**
 * @typedef {Object} Attribute
 * @property {string} key - The key of the attribute.
 * @property {string} value - The value of the attribute.
 */

/**
 * @typedef {Object} CartAutomaticDiscountAllocation
 * @property {MoneyV2} discountedAmount - The discounted amount.
 */

/**
 * @typedef {Object} Product
 * @property {string} title - The title of the product.
 */

/**
 * @typedef {Object} ProductVariant
 * @property {string} id - The unique identifier of the product variant.
 * @property {string} title - The title of the product variant.
 * @property {string} sku - The SKU of the product variant.
 * @property {MoneyV2} priceV2 - The price of the product variant.
 * @property {Product} product - The product associated with the product variant.
 */

/**
 * @typedef {Object} CartLine
 * @property {string} id - The unique identifier of the cart line.
 * @property {number} quantity - The quantity of the cart line.
 * @property {ProductVariant} merchandise - The merchandise of the cart line.
 * @property {Array.<CartAutomaticDiscountAllocation>} discountAllocations - The discount allocations of the cart line.
 * @property {SellingPlanAllocation} sellingPlanAllocation - The selling plan allocation of the cart line.
 * @property {Array.<Attribute>} attributes - The attributes of the cart line.
 */

/**
 * @typedef {Object} StorefrontApiCart
 * @property {string} id - The unique identifier of the cart.
 * @property {string} checkoutUrl - The checkout URL of the cart.
 * @property {CartCost} cost - The cost of the cart.
 * @property {Array.<Attribute>} attributes - The attributes of the cart.
 * @property {Array} discountAllocations - The discount allocations of the cart.
 * @property {Array.<CartLine>} lines - The lines of the cart.
 */

/**
 * @typedef {Object} SellingPlanAllocation
 * @property {SellingPlan} sellingPlan - The selling plan of the selling plan allocation.
 */

/**
 * @typedef {Object} SellingPlan
 * @property {string} id - The unique identifier of the selling plan.
 */
// endregion
import { CartAdapterBase } from './base';
/**
 * An adapter class to convert a cart model from the Shopify Storefront API to the TrackersJS model.
 * Shopify Storefront API: https://shopify.dev/docs/api/storefront/2023-10/mutations/cartcreate
 * @class StorefrontCartAdapter
 * @extends CartAdapterBase
 */

export var StorefrontCartAdapter = /*#__PURE__*/function (_CartAdapterBase) {
  _inherits(StorefrontCartAdapter, _CartAdapterBase);

  var _super = _createSuper(StorefrontCartAdapter);

  /**
   * Create an adapter for Shopify Storefront API Carts.
   * @param {Array<CartLineInput>} addedCartItems - Items that were added to the cart.
   * @param {StorefrontApiCart} cart - Cart object returned from Shopify Storefront API.
   */
  function StorefrontCartAdapter(addedCartItems, cart) {
    var _this;

    _classCallCheck(this, StorefrontCartAdapter);

    _this = _super.call(this, addedCartItems, cart);

    if (!(cart !== null && cart !== void 0 && cart.lines)) {
      console.error('StorefrontCartAdapter: cart.lines is missing');
    }

    return _this;
  }

  _createClass(StorefrontCartAdapter, [{
    key: "findCartLine",
    value: function findCartLine(merchandiseId) {
      return this.cart.lines.find(function (cartItem) {
        return cartItem.merchandise.id === merchandiseId;
      });
    }
  }, {
    key: "getPerItemDiscountedPrice",
    value: function getPerItemDiscountedPrice(cartLine) {
      var perItemPrice = Number(cartLine.merchandise.priceV2.amount);
      var cartLineDiscount = cartLine.discountAllocations.reduce(function (discountTotal, _ref) {
        var discountedAmount = _ref.discountedAmount;
        return discountTotal + Number(discountedAmount.amount);
      }, 0);
      return perItemPrice - cartLineDiscount / cartLine.quantity;
    }
  }, {
    key: "toAddToCartModel",
    value: function toAddToCartModel() {
      var _this2 = this;

      var value = this.addedCartItems.reduce(function (total, _ref2) {
        var merchandiseId = _ref2.merchandiseId,
            addedQuantity = _ref2.quantity;
        var cartLine = _this2.findCartLine(merchandiseId) || {};
        return total + _this2.getPerItemDiscountedPrice(cartLine) * addedQuantity;
      }, 0);
      var items = this.addedCartItems.map(function (_ref3) {
        var merchandiseId = _ref3.merchandiseId,
            addedQuantity = _ref3.quantity;
        var cartLine = _this2.findCartLine(merchandiseId) || {};
        return _objectSpread(_objectSpread({}, cartLine), {}, {
          id: Number(merchandiseId.split('/').pop()),
          title: cartLine.merchandise.product.title,
          variantTitle: cartLine.merchandise.title,
          price: _this2.getPerItemDiscountedPrice(cartLine),
          quantity: addedQuantity
        });
      });
      return {
        value: value,
        currency: 'USD',
        items: items,
        source: 'shopify-storefront-api',
        rebuildCartUrl: this.getRebuildCartUrl()
      };
    }
    /**
     * Convert the cart data to a Begin Checkout event model.
     */

  }, {
    key: "toBeginCheckoutModel",
    value: function toBeginCheckoutModel() {
      var _this$cart, _this$cart$cost, _this$cart$cost$subto, _this$cart2, _this$cart2$cost, _this$cart2$cost$subt;

      return {
        value: Number((_this$cart = this.cart) === null || _this$cart === void 0 ? void 0 : (_this$cart$cost = _this$cart.cost) === null || _this$cart$cost === void 0 ? void 0 : (_this$cart$cost$subto = _this$cart$cost.subtotalAmount) === null || _this$cart$cost$subto === void 0 ? void 0 : _this$cart$cost$subto.amount),
        currency: ((_this$cart2 = this.cart) === null || _this$cart2 === void 0 ? void 0 : (_this$cart2$cost = _this$cart2.cost) === null || _this$cart2$cost === void 0 ? void 0 : (_this$cart2$cost$subt = _this$cart2$cost.subtotalAmount) === null || _this$cart2$cost$subt === void 0 ? void 0 : _this$cart2$cost$subt.currencyCode) || 'USD',
        items: this.cart.lines.map(function (item) {
          var _item$merchandise, _item$merchandise$id, _item$merchandise$id$, _item$merchandise2, _item$merchandise2$pr, _item$merchandise3;

          return {
            item_id: (_item$merchandise = item.merchandise) === null || _item$merchandise === void 0 ? void 0 : (_item$merchandise$id = _item$merchandise.id) === null || _item$merchandise$id === void 0 ? void 0 : (_item$merchandise$id$ = _item$merchandise$id.split('/')) === null || _item$merchandise$id$ === void 0 ? void 0 : _item$merchandise$id$.pop(),
            item_name: (_item$merchandise2 = item.merchandise) === null || _item$merchandise2 === void 0 ? void 0 : (_item$merchandise2$pr = _item$merchandise2.product) === null || _item$merchandise2$pr === void 0 ? void 0 : _item$merchandise2$pr.title,
            item_variant: (_item$merchandise3 = item.merchandise) === null || _item$merchandise3 === void 0 ? void 0 : _item$merchandise3.title
          };
        })
      };
    }
    /**
     * Convert the cart data to an Initiate Checkout event model for Facebook
     */

  }, {
    key: "toInitiateCheckoutModel",
    value: function toInitiateCheckoutModel() {
      var model = this.toAddToCartModel();
      return _objectSpread(_objectSpread({}, model), {}, {
        // prevents the Facebook 'AddToCart' event from being firing by the Facebook Tracker
        fromCart: true
      });
    }
    /**
     * Generator function to iterate over the line items in the cart
     * @returns {Generator<*, void, *>}
     */

  }, {
    key: "lineItemGenerator",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function lineItemGenerator() {
      var _iterator, _step, line;

      return regeneratorRuntime.wrap(function lineItemGenerator$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-next-line no-unused-vars
              _iterator = _createForOfIteratorHelper(this.cart.lines.reverse());
              _context.prev = 1;

              _iterator.s();

            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 9;
                break;
              }

              line = _step.value;
              _context.next = 7;
              return line;

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, lineItemGenerator, this, [[1, 11, 14, 17]]);
    })
    /**
     * Get the variant ID of a line item.
     * @param {CartLine} line
     * @returns {string}
     */

  }, {
    key: "lineItemVariantId",
    value: function lineItemVariantId(line) {
      var _line$merchandise, _line$merchandise$id, _line$merchandise$id$;

      return line === null || line === void 0 ? void 0 : (_line$merchandise = line.merchandise) === null || _line$merchandise === void 0 ? void 0 : (_line$merchandise$id = _line$merchandise.id) === null || _line$merchandise$id === void 0 ? void 0 : (_line$merchandise$id$ = _line$merchandise$id.split('/')) === null || _line$merchandise$id$ === void 0 ? void 0 : _line$merchandise$id$.pop();
    }
    /**
     * Get the selling plan ID of a line item.
     * @param {CartLine} line
     * @returns {string}
     */

  }, {
    key: "lineItemSellingPlanId",
    value: function lineItemSellingPlanId(line) {
      var _line$sellingPlanAllo, _line$sellingPlanAllo2, _line$sellingPlanAllo3;

      return (_line$sellingPlanAllo = line.sellingPlanAllocation) === null || _line$sellingPlanAllo === void 0 ? void 0 : (_line$sellingPlanAllo2 = _line$sellingPlanAllo.sellingPlan) === null || _line$sellingPlanAllo2 === void 0 ? void 0 : (_line$sellingPlanAllo3 = _line$sellingPlanAllo2.id) === null || _line$sellingPlanAllo3 === void 0 ? void 0 : _line$sellingPlanAllo3.split('/').pop();
    }
    /**
     * Generator function to iterate over the line item properties
     * @param {CartLine} line
     * @returns {Generator<Attribute, Attribute, Attribute>}
     */

  }, {
    key: "lineItemPropertiesGenerator",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function lineItemPropertiesGenerator(line) {
      var _iterator2, _step2, attribute;

      return regeneratorRuntime.wrap(function lineItemPropertiesGenerator$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // eslint-disable-next-line no-unused-vars
              _iterator2 = _createForOfIteratorHelper(line.attributes);
              _context2.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 9;
                break;
              }

              attribute = _step2.value;
              _context2.next = 7;
              return attribute;

            case 7:
              _context2.next = 3;
              break;

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);

              _iterator2.e(_context2.t0);

            case 14:
              _context2.prev = 14;

              _iterator2.f();

              return _context2.finish(14);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, lineItemPropertiesGenerator, null, [[1, 11, 14, 17]]);
    })
    /**
     * Generates key-value pairs for the attributes object
     * @param {Cart} cart
     * @returns {Generator<Attribute, Attribute, Attribute>}   */

  }, {
    key: "cartAttributesGenerator",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function cartAttributesGenerator(cart) {
      var _iterator3, _step3, attribute;

      return regeneratorRuntime.wrap(function cartAttributesGenerator$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // eslint-disable-next-line no-unused-vars
              _iterator3 = _createForOfIteratorHelper(cart.attributes);
              _context3.prev = 1;

              _iterator3.s();

            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context3.next = 9;
                break;
              }

              attribute = _step3.value;
              _context3.next = 7;
              return attribute;

            case 7:
              _context3.next = 3;
              break;

            case 9:
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);

              _iterator3.e(_context3.t0);

            case 14:
              _context3.prev = 14;

              _iterator3.f();

              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, cartAttributesGenerator, null, [[1, 11, 14, 17]]);
    })
  }]);

  return StorefrontCartAdapter;
}(CartAdapterBase);